import Alternative from "./views/pages/admin/dashboards/Alternative";

import Dialogues from "./views/pages/admin/management/Dialogues";
import TopStudent from "./views/pages/admin/management/TopStudent";
import VideoLink from "./views/pages/admin/management/VideoLink";
import Vocabulary from "./views/pages/admin/management/Vocabulary";
import Users from './views/pages/admin/management/Users';
import Question from "./views/pages/admin/management/Question";
import MultipleChoiceExam from './views/pages/user/question-bank/MultipleChoiceExam';

const routes = [
  {
    path: "/dashboard",
    name: "Dashboards",
    icon: "ni ni-shop text-primary",
    component: Alternative,
    layout: "/admin"
  },
  {
    path: "/users",
    name: "Users",
    icon: "fas fa-user text-success",
    component: Users,
    layout: "/admin"
  },
  {
    path: "/dialogues",
    name: "Dialogues",
    icon: "fas fa-comments text-red",
    component: Dialogues,
    layout: "/admin"
  },
  {
    path: "/student",
    name: "Top passed students",
    icon: "fas fa-trophy text-info",
    component: TopStudent,
    layout: "/admin"
  },
  {
    path: "/video-link",
    name: "VideoLink Tutorials",
    icon: "fab fa-youtube text-green",
    component: VideoLink,
    layout: "/admin"
  },
  {
    path: "/vocabulary",
    name: "Vocabulary",
    icon: "fas fa-file-word text-info",
    component: Vocabulary,
    layout: "/admin"
  },
  {
    path: "/question",
    name: "Question",
    icon: "fas fa-question text-danger",
    component: Question,
    layout: "/admin"
  },
];

export default routes;
